import { Input } from "@itandi/itandi-bb-ui/Input";
import { InputRadio } from "@itandi/itandi-bb-ui/InputRadio";
import { PresentationChip } from "@itandi/itandi-bb-ui/PresentationChip";
import { useFormContext } from "react-hook-form";
import type { DealParam, RelatedDealParam } from "~/models/DealForm";
import Styles from "./Block.module.scss";

type Props = {
	isTenantEmailDisabled?: boolean;
	isTenantNameDisabled?: boolean;
	isTenantNameKanaDisabled?: boolean;
	isTenantTelDisabled?: boolean;
};

export const TenantBlockBase: React.FC<Props> = ({
	isTenantNameDisabled = false,
	isTenantNameKanaDisabled = false,
	isTenantTelDisabled = false,
	isTenantEmailDisabled = false
}) => {
	const { register, formState, watch } = useFormContext<
		DealParam | RelatedDealParam
	>();
	const { errors } = formState;
	const dealType: "restoration" | "repair" | "other" | null = watch("dealType");
	const inspectionBy = watch("inspectionBy");

	return (
		<>
			{dealType === "restoration" && (
				<div className={Styles.FormRow}>
					<div className={Styles.FormLabel}>
						<span className={Styles.FormLabelText}>立会者</span>
						<PresentationChip variant="red">必須</PresentationChip>
					</div>
					<div className={Styles.FormContent}>
						<div className={Styles.InputRadioGroup}>
							<InputRadio
								label="施工会社"
								value="vendor"
								{...register("inspectionBy")}
							/>
							<InputRadio
								label="管理会社"
								value="company"
								{...register("inspectionBy")}
							/>
							<InputRadio
								label="なし"
								value="none"
								{...register("inspectionBy")}
							/>
						</div>
						<div className={Styles.ErrorMessage}>
							{errors.inspectionBy?.message}
						</div>
					</div>
				</div>
			)}
			<div className={Styles.FormRow}>
				<div className={Styles.FormLabel}>
					<span className={Styles.FormLabelText}>氏名</span>
					{inspectionBy === "vendor" ? (
						<PresentationChip variant="red">必須</PresentationChip>
					) : null}
				</div>
				<div className={Styles.FormContent}>
					<div className={Styles.NameKanaGroup}>
						<div className={Styles.NameInputWrapper}>
							<Input
								disabled={isTenantNameDisabled}
								isInvalid={!!errors.tenantName}
								placeholder="例）内装 太郎"
								{...register("tenantName")}
							/>
						</div>
						{errors.tenantName ? (
							<div className={Styles.ErrorMessage}>
								{errors.tenantName.message}
							</div>
						) : null}
						<div className={Styles.NameInputLabel}>カナ</div>
						<div>
							<Input
								disabled={isTenantNameKanaDisabled}
								isInvalid={!!errors.tenantNameKana}
								placeholder="例）ナイソウ タロウ"
								{...register("tenantNameKana")}
							/>
						</div>
						{errors.tenantNameKana ? (
							<div className={Styles.ErrorMessage}>
								{errors.tenantNameKana.message}
							</div>
						) : null}
					</div>
				</div>
			</div>
			<div className={Styles.FormRow}>
				<div className={Styles.FormLabel}>
					<span className={Styles.FormLabelText}>電話番号</span>
					{inspectionBy === "vendor" ? (
						<PresentationChip variant="red">必須</PresentationChip>
					) : null}
				</div>
				<div className={Styles.FormContent}>
					<div className={Styles.InputWrapper}>
						<Input
							disabled={isTenantTelDisabled}
							isInvalid={!!errors.tenantTel}
							placeholder="例）090-0000-0000"
							{...register("tenantTel")}
						/>
					</div>
					{errors.tenantTel ? (
						<div className={Styles.ErrorMessage}>
							{errors.tenantTel.message}
						</div>
					) : null}
				</div>
			</div>
			<div className={Styles.FormRow}>
				<div className={Styles.FormLabel}>
					<span className={Styles.FormLabelText}>メールアドレス</span>
				</div>
				<div className={Styles.FormContent}>
					<div className={Styles.InputWrapper}>
						<Input
							disabled={isTenantEmailDisabled}
							isInvalid={!!errors.tenantEmail}
							placeholder="例）sample@example.com"
							{...register("tenantEmail")}
						/>
					</div>
					{errors.tenantEmail ? (
						<div className={Styles.ErrorMessage}>
							{errors.tenantEmail.message}
						</div>
					) : null}
				</div>
			</div>
		</>
	);
};
